import React, { useEffect, useContext, useState, createRef, Fragment } from 'react'
import { connect } from 'react-redux'
import { Grid, Box } from '@material-ui/core'

import {
  getUserRoles,
  activateUserDetail,
  getBoatByType,
  getLatestBoats,
  getPopularBoats,
  getTopRatedBoats,
  getGlobalMinimumPriceBoats,
  clearCityWiseBoats,
  clearCategoryWiseBoats,
  getAllAuctionRooms,
  getBoatTypeStart,
  getModuleWiseBanners,
  getBoatSearchMinimumValues,
  notifyMe,
  getAllWishlists,
  getCityWiseBoats,
  clearAdminLoginFlag,
  getUserById,
  getYachts,
  // getRecommendedTrips,
} from '../../redux/actions'
import { getCategoryWiseVideos } from '../../redux/actions/VideoAction'
import { getCategoryWiseAdvertisements } from '../../redux/actions/advertisementAction'

import { Layout } from '../../components/'
import ManufactureCarousal from '../../components/carouselComponent/homePageCarousel/manufactureCarousel'
import { BoatTypeCarousel } from '../../components/carouselComponent/homePageCarousel/BoatTypeCarousel'
import SellAroundCards from '../../components/staticComponent/sellAroundCards'
import ServicesMarinaStorage from '../../components/staticComponent/servicesMarinaStorage'
import { getRatio, getHeightRatio } from '../../helpers/ratio'
import CommonBanner from '../../components/mainBanner/commonBanner'
import RegisterCard from '../../components/staticComponent/registerCard'
import { VideoComponent } from '../../components/videoComponent/videoComponent'
import { VideoModel } from '../../components/videoComponent/videoModel'
import FormCarousal from '../../components/staticComponent/FormCarousal'
import { AuctionCarousel } from '../../components/carouselComponent/homePageCarousel/auctionCarousal'
import { BoatGrid } from '../../components/gridComponents/boatGrid'
import VideoThumbnail from 'react-video-thumbnail'
import {
  pagination,
  moduleCategory,
  dimension,
  mediaCategory,
  advertisementCategory,
  activationType,
  marginCarousel,
  responsiveCarousel,
  showAll,
} from '../../util/enums/enums'
import UserContext from '../../UserContext'
import { objectToQuerystring } from '../../helpers/routeHelper'
import { lowerHypenCase, replaceSlashToDash } from '../../helpers/string'
import { getLocalStorageItem, setLocalStorageItem } from '../../helpers/storageHelper'
import { popUpMessage } from '../../helpers/confirmationPopup'

import './home.scss'
import '../../styles/responsive.scss'
import { notificationEnum } from '../../util/enums/notificationEnum'
import HelmetMetaData from '../../components/helmetComponent/HelmetMeta'
import { TripCarousels } from '../../components/carouselComponent/tripsCarousels'
import { get } from 'lodash'
import { listenForTokenChanges, socket } from '../../socket'
import { socketEvent } from '../../util/enums/socketEnums'
import { clear_getStaticPages, getStaticPages } from '../../redux/actions/pageInfoByTypeAction'
import HeroSearch from './hero-search'

const mustBuyCarousel = {
  isBrowser: 5,
  isTablet: 2,
  isMobile: 1,
}
const auctionCarouselItem = {
  isBrowser: 4,
  isTablet: 4,
  isMobile: 1,
}
const ExploreAdamSeaCarousel = {
  isBrowser: 5,
  isTablet: 3,
  isMobile: 1,
}

const Home = props => {
  const {
    getUserRoles,
    history,
    activateUserDetail,
    getCategoryWiseVideos,
    categoryVideos,
    isSearched,
    getBoatByType,
    getLatestBoats,
    getPopularBoats,
    getTopRatedBoats,
    featureBoats,
    bestDealBoats,
    totalBestDealBoats,
    mustBuyBoats,
    totalMustBuyBoats,
    latestBoats,
    popularBoats,
    getGlobalMinimumPriceBoats,
    cityLists,
    clearCityWiseBoats,
    clearCategoryWiseBoats,
    getAllAuctionRooms,
    allAuctionRooms,
    allAuctionRoomCounts,
    getBoatTypeStart,
    getModuleWiseBanners,
    homeBanner,
    boatTypes,
    getBoatSearchMinimumValues,
    boatSearchValues,
    notifyInput,
    notifyMe,
    convertWishlists,
    getAllWishlists,
    totalLatestBoats,
    adminLoginAsUserSuccess,
    adminLoginAsUserError,
    clearAdminLoginFlag,
    location,
    isMailVerify,
    isMailVerifyError,
    getUserById,
    adminBoatTypes,
    advertisements,
    getCategoryWiseAdvertisements,
    totalPopularBoats,
    // getRecommendedTrips,
    // recommendedTrips,
    // totalRecommendedTrips,
    getYachts,
    yachts,
  } = props

  const mainRef = createRef()

  const { country } = useContext(UserContext)
  const [videoFlag, setVideoFlag] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')
  const [videoThumbnail, setVideoThumbnail] = useState('')
  const [videoWidth, setVideoWidth] = useState(dimension.homePageVideo.width)
  const [videoHeight, setVideoHeight] = useState(dimension.homePageVideo.height)

  useEffect(() => {
    if (location && location.search) {
      const urlParams = new URLSearchParams(location.search)

      if (urlParams.has('token')) {
        const token = urlParams.get('token')
        activateUserDetail({ token, activationType: activationType.EMAIL })
      }
    }
  }, [])

  useEffect(() => {
    props.getStaticPages({ slug: 'homepage-bottom-878' })
  }, [])

  useEffect(() => {
    if (props.staticPages?.success || props.staticPages?.failure) {
      props.clear_getStaticPages()
    }
  }, [props.staticPages])

  useEffect(() => {
    if (adminLoginAsUserSuccess) {
      history.push('/dashboard')
      clearAdminLoginFlag()
    } else if (adminLoginAsUserError) {
      history.push('/login')
      clearAdminLoginFlag()
    }
  }, [adminLoginAsUserSuccess, adminLoginAsUserError, clearAdminLoginFlag, history])

  useEffect(() => {
    if (convertWishlists) {
      getAllWishlists()
    }
  }, [convertWishlists, getAllWishlists])

  useEffect(() => {
    if (isMailVerify) {
      if (getLocalStorageItem('userId')) {
        getUserById(getLocalStorageItem('userId'))
      }
      popUpMessage(notificationEnum.EMAIL_VERIFY.message, 'Success')
      history.replace('/')
    } else if (isMailVerifyError) {
      popUpMessage('Something went wrong while verifying email, please resend link and try again.')
      history.replace('/')
    }
  }, [isMailVerify, isMailVerifyError, getUserById, history])

  // SEARCH BOAT CARD
  const searchBoatHandler = values => {
    const queryResult = objectToQuerystring(values)

    history.push({
      pathname: '/search-boats',
      search: `${queryResult && queryResult}`,
    })
  }
  const zoomWidth = () => {
    const videoWidth = getRatio(dimension, 'marinaStorageVideo', '.section-heading')
    setVideoWidth(videoWidth)
    const videoHeight = getHeightRatio(dimension, 'marinaStorageVideo', '.section-heading')
    setVideoHeight(videoHeight)
  }

  useEffect(() => {
    // if (!location.search) {
      getUserRoles()

      getModuleWiseBanners({ type: mediaCategory.home.type, fieldName: mediaCategory.home.fieldName })
      getBoatSearchMinimumValues()

      getBoatTypeStart({ page: pagination.PAGE_COUNT, limit: pagination.PAGE_RECORD_LIMIT, isAllTypes: true })
      getBoatTypeStart({ page: pagination.PAGE_COUNT, limit: pagination.PAGE_RECORD_LIMIT })

      getBoatByType({ input: { fieldName: 'featureStatus' }, page: pagination.PAGE_COUNT, limit: pagination.MARKET_PAGE_LIMIT })

      getGlobalMinimumPriceBoats()

      getBoatByType({
        input: { fieldName: 'bestDealStatus' },
        page: pagination.PAGE_COUNT,
        limit: pagination.MARKET_PAGE_LIMIT,
      })
      getLatestBoats({ page: pagination.PAGE_COUNT, limit: pagination.MARKET_PAGE_LIMIT })
      getBoatByType({ input: { fieldName: 'mustBuyStatus' }, page: pagination.PAGE_COUNT, limit: pagination.MARKET_PAGE_LIMIT })
      getPopularBoats({ page: pagination.PAGE_COUNT, limit: pagination.POPULAR_LIMIT })

      // getTopRatedBoats();
      getCategoryWiseAdvertisements(advertisementCategory.HOME)
      getAllAuctionRooms({
        page: pagination.PAGE_COUNT,
        limit: pagination.MARKET_PAGE_LIMIT,
      })
      getCategoryWiseVideos({ type: moduleCategory.HOME })

      getYachts()

      // getRecommendedTrips({
      //   country,
      //   page: pagination.PAGE_COUNT,
      //   limit: pagination.PAGE_RECORD_LIMIT,
      // })

      zoomWidth()
      window.addEventListener('resize', zoomWidth)
    // }

    return () => {
      window.removeEventListener('resize', zoomWidth)
    }
  }, [
    country,
    getAllAuctionRooms,
    getGlobalMinimumPriceBoats,
    getBoatByType,
    getCategoryWiseVideos,
    getLatestBoats,
    getPopularBoats,
    getTopRatedBoats,
    getUserRoles,
    getBoatTypeStart,
    getModuleWiseBanners,
    getBoatSearchMinimumValues,
    getCategoryWiseAdvertisements,
    location,
  ])

  const getCategoryWiseBoatsHandler = value => {
    clearCategoryWiseBoats()
    value && window.open(`/category-wise-boats/${lowerHypenCase(replaceSlashToDash(value.name))}/${value.id}`, '_blank')
  }

  function onScroll() {
    const scrollY = window.scrollY //Don't get confused by what's scrolling - It's not the window
    const scrollTop = mainRef.current.scrollTop
  }

  const setVideoUrlHandler = (url, thumbnail) => {
    setVideoFlag(true)
    setVideoUrl(url)
    setVideoThumbnail(thumbnail)
  }

  const closeVideo = () => {
    setVideoFlag(false)
  }
  const newLatestBoats = latestBoats.slice(0, 29)
  return (
    <>
      <Layout className="home-layout-page">
        <div ref={mainRef} className="home-page" onScroll={onScroll}>
          {homeBanner && homeBanner.length > 0 && (
            <div className="home-carousal">
              <CommonBanner data={homeBanner} />
              {/* {adminBoatTypes && adminBoatTypes.length > 0 && (
                <FormCarousal
                  searchBoat={searchBoatHandler}
                  boatTypes={adminBoatTypes}
                  boatSearchValues={boatSearchValues}
                  notifyMe={notifyMe}
                  notifyInput={notifyInput}
                />
              )} */}
              
              <HeroSearch />
            </div>
          )}

          <div className="container100 home-content">
            <Grid container>
              {/* <Grid item xs={12} className="zoom--gird--15">
                <h1 className="r-h1 mb-0">
                  <Box className="section-heading section-heading-first" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Explore AdamSea
                  </Box>
                </h1>
                <ServicesMarinaStorage type="home" className="mb-20" marketClassName="home--main--market--name--div" />
              </Grid> */}

              {boatTypes && boatTypes.length > 0 && (
                <Grid item xs={12} className="zoom--gird--15 adam-slid-grid-5 cor-wrp-up">
                  <Box className="section-heading" id="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Buy direct from the manufacturer
                  </Box>
                  <ManufactureCarousal
                    items={ExploreAdamSeaCarousel}
                    carouselData={boatTypes}
                    slidesToScroll={5}
                    getCategoryWiseBoats={value => getCategoryWiseBoatsHandler(value)}
                  />
                </Grid>
              )}

              {featureBoats && featureBoats.length > 0 && (
                <Grid item xs={12}>
                  <Box className="section-heading zoom--heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Featured Boats
                  </Box>
                  <div className="grid--adjust--zoom adam-grid-3">
                    <BoatGrid
                      showType="featured-boats"
                      itemsLength={10}
                      showAllText="featured boats"
                      xs={12}
                      sm={3}
                      isTopLabel
                      isBottomRating
                      className="featured--boats--grid"
                      isFeature
                      boatGrid={featureBoats}
                      isCustomWidth
                      route
                    />
                  </div>
                </Grid>
              )}

              {cityLists && cityLists.length > 0 && (
                <Grid item xs={12} className="zoom--gird--15 adam-card-5">
                  <Box className="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Boats for sale around the world
                  </Box>
                  <SellAroundCards data={cityLists} clearCityWiseBoats={clearCityWiseBoats} limit={5} showAllText={'boats for sale around the world'} />
                </Grid>
              )}

              {advertisements && advertisements.length > 0 && (
                <Grid item xs={12} className="mt-md-5 registerCardCont single--register--card zoom--gird--15 adam-card-banner">
                  <div className="home--advertisement--section">
                    <RegisterCard adData={advertisements[0]} />
                  </div>
                </Grid>
              )}

              {bestDealBoats && bestDealBoats.length > 0 && (
                <Grid item xs={12}>
                  <Box className="section-heading zoom--heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    AdamSea's best deals on recommended boats
                  </Box>
                  <div className="grid--adjust--zoom adam-grid-4">
                    <BoatGrid
                      xs={12}
                      sm={3}
                      isTopLabel
                      total={totalBestDealBoats}
                      route
                      className="best--recommended--boats--grid"
                      showType="best-deal-boats"
                      showAllText="AdamSea's best deals on recommended boats"
                      itemsLength={8}
                      isBestDeal
                      boatGrid={bestDealBoats}
                    />
                  </div>
                </Grid>
              )}

              {/* {recommendedTrips?.length > 0 && (
                <Grid item xs={12}>
                  <Box className="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    AdamSea Recommended Trips
                  </Box>

                  <TripCarousels
                    customWidthItem={3}
                    itemsLength={8}
                    totalLength={totalRecommendedTrips}
                    items={{
                      isBrowser: 3,
                      isTablet: 3,
                      isMobile: 1,
                    }}
                    showType={showAll.recommended}
                    carouselData={recommendedTrips}
                    dimensionKey="recommended"
                    margin={marginCarousel.sharedTrip}
                    responsiveNumber={responsiveCarousel.recommendedTrip}
                  />
                </Grid>
              )} */}

              {latestBoats && latestBoats.length > 0 && (
                <Grid item xs={12}>
                  <Box className="section-heading zoom--heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Recent boats for sale in our market
                  </Box>
                  <div className="grid--adjust--zoom adam-grid-4">
                    <BoatGrid
                      xs={12}
                      sm={3}
                      showType="recently-added-boats"
                      className="best--recommended--boats--grid"
                      itemsLength={8}
                      boatGrid={latestBoats}
                      total={totalLatestBoats}
                      isRecentSellBoat
                      showAllText="recent boats for sale in our market"
                    />
                  </div>
                </Grid>
              )}
              {advertisements && advertisements.length > 1 && (
                <Grid item xs={12} className="zoom--gird--15 registerCardCont adam-card-homepage-hide adam-card-banner-2">
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <div className="double-card">
                        <RegisterCard isSpace isDouble adData={advertisements[1]} />
                      </div>
                    </Grid>
                    {advertisements && advertisements.length > 2 && (
                      <Grid item xs={6}>
                        <div className="double-card">
                          <RegisterCard isSpace2 isDouble adData={advertisements[2]} />
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}

              {mustBuyBoats && mustBuyBoats.length > 0 && (
                <Grid item xs={12} className="grid--space--home--must-buy zoom--gird--15 adam-card-5">
                  <Box className="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Small boats for sale
                  </Box>

                  <BoatGrid
                    showType="must-buy-boats"
                    itemsLength={5}
                    isTopLabel
                    route
                    isBottomRating
                    boatGrid={mustBuyBoats}
                    isCustomWidth
                    showAllText="small boats for sale"
                    className="best--sales--market--grid"
                    isBestMarket
                    total={totalMustBuyBoats}
                    isLittleBoat
                  />
                </Grid>
              )}

              {popularBoats && popularBoats.length > 0 && (
                <Grid item xs={12} className="grid--space--home grid--space--best-market adam-card-5">
                  <Box className="section-heading zoom--heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Boats for sale in our market
                  </Box>
                  <div className="grid--adjust--zoom">
                    <BoatGrid
                      showType="most-popular-boats"
                      itemsLength={popularBoats.length}
                      xs={12}
                      showAllText="boats for sale in our market"
                      sm={3}
                      total={totalPopularBoats}
                      isTopLabel
                      isBottomRating
                      boatGrid={popularBoats}
                      isCustomWidth
                      className="best--sales--market--grid"
                      isBestMarket
                    />
                  </div>
                </Grid>
              )}

              {yachts && yachts?.items?.length > 0 && (
                <Grid item xs={12} className="grid--space--home grid--space--best-market adam-card-5">
                  <Box className="section-heading zoom--heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Yachts and Super Yachts
                  </Box>
                  <div className="grid--adjust--zoom">
                    <BoatGrid
                      xs={12}
                      sm={3}
                      showType="recently-added-boats"
                      className="best--recommended--boats--grid"
                      itemsLength={8}
                      boatGrid={yachts.items}
                      total={yachts.total}
                      isRecentSellBoat
                      showAllText="Yachts and Super Yachts"
                    />
                  </div>
                </Grid>
              )}

              {allAuctionRooms && allAuctionRooms.length > 0 && (
                <Grid className="auction-room zoom--gird--15 adam-auc-card-4" item xs={12}>
                  <Box className="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}>
                    Auction Rooms
                  </Box>
                  <AuctionCarousel
                    items={auctionCarouselItem}
                    carouselData={allAuctionRooms}
                    itemsLength={4}
                    total={allAuctionRoomCounts}
                    showAllText="auction rooms"
                  />
                </Grid>
              )}
            </Grid>

            {categoryVideos && categoryVideos.length > 0 && (
              <div className="container100 adam-mov-card-3">
                <Grid container>
                  <Grid item xs={12}>
                    <Box className="section-heading" fontSize={24} fontWeight={500} letterSpacing={0.5}></Box>
                    <Grid item xs={12} className="home-video-section zoom--gird--15">
                      <Grid container spacing={2} className="home-video-grid-view video-gapping-space-common">
                        {categoryVideos &&
                          categoryVideos.map((video, index) => {
                            if (index < 3) {
                              return (
                                <>
                                  <Fragment key={video.id}>
                                    <VideoComponent
                                      setVideoUrlHandler={thum => setVideoUrlHandler(get(video, 'url[0].url', ''), thum)}
                                      video={video}
                                      videoWidth={videoWidth}
                                      videoHeight={videoHeight}
                                    />
                                  </Fragment>
                                </>
                              )
                            }
                          })}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <VideoModel videoFlag={videoFlag} videoUrl={videoUrl} thumbnail={videoThumbnail} closeVideo={closeVideo} />
              </div>
            )}

            {get(props.staticPages, 'data[0].pageContent', '') && (
              <div style={{ marginTop: 30, padding: '16px 24px', borderRadius: 8, background: '#dff0f2' }}>
                <div className="d-flex">
                  <div style={{ flexShrink: 0 }}>
                    <img src={require('../../assets/images/BUY.svg')} alt="bell" height={28} style={{ height: 28 }} />
                  </div>
                  <div style={{ margin: 0, marginLeft: 20, fontSize: 16 }} dangerouslySetInnerHTML={{ __html: get(props.staticPages, 'data[0].pageContent', '') }} />
                </div>
              </div>
            )}
          </div>
        </div>
      </Layout>
    </>
  )
}

const mapStateToProps = state => ({
  categoryVideos: state.videoReducer.categoryVideos,
  isSearched: state.boatReducer.isSearched,
  featureBoats: state.boatReducer.featureBoats,
  bestDealBoats: state.boatReducer.bestDealBoats,
  totalBestDealBoats: state.boatReducer.totalBestDealBoats,
  mustBuyBoats: state.boatReducer.mustBuyBoats,
  totalMustBuyBoats: state.boatReducer.totalMustBuyBoats,
  latestBoats: state.boatReducer.latestBoats,
  totalLatestBoats: state.boatReducer.totalLatestBoats,
  popularBoats: state.boatReducer.popularBoats,
  topRatedBoats: state.boatReducer.topRatedBoats,
  cityLists: state.dashboardReducer.cityLists,
  allAuctionRooms: state.boatReducer && state.boatReducer.allAuctionRooms,
  allAuctionRoomCounts: state.boatReducer && state.boatReducer.allAuctionRoomCounts,
  boatTypes: state.boatReducer.boatTypes,
  adminBoatTypes: state.boatReducer.adminBoatTypes,
  advertisements: state.dashboardReducer[mediaCategory.home.adField],
  homeBanner: state.dashboardReducer[mediaCategory.home.fieldName],
  totalPopularBoats: state.boatReducer.totalPopularBoats,
  boatSearchValues: state.boatReducer.boatSearchValues,
  notifyInput: state.dashboardReducer.notifyInput,
  convertWishlists: state.dashboardReducer.convertWishlists,
  adminLoginAsUserSuccess: state.loginReducer.adminLoginAsUserSuccess,
  adminLoginAsUserError: state.loginReducer.adminLoginAsUserError,
  isMailVerify: state.loginReducer.isMailVerify,
  isMailVerifyError: state.loginReducer.isMailVerifyError,
  // recommendedTrips: state.rentReducer.recommendedTrips,
  // totalRecommendedTrips: state.rentReducer.totalRecommendedTrips,
  staticPages: state.pageInfoByTypeReducer.staticPages,
  yachts: state.boatReducer.yachts,
})

const mapDispatchToProps = dispatch => ({
  getUserRoles: () => dispatch(getUserRoles()),
  activateUserDetail: data => dispatch(activateUserDetail(data)),
  getCategoryWiseVideos: data => dispatch(getCategoryWiseVideos(data)),
  getBoatByType: data => dispatch(getBoatByType(data)),
  getLatestBoats: data => dispatch(getLatestBoats(data)),
  getPopularBoats: data => dispatch(getPopularBoats(data)),
  getTopRatedBoats: data => dispatch(getTopRatedBoats(data)),
  getGlobalMinimumPriceBoats: data => dispatch(getGlobalMinimumPriceBoats(data)),
  clearCityWiseBoats: () => dispatch(clearCityWiseBoats()),
  clearCategoryWiseBoats: () => dispatch(clearCategoryWiseBoats()),
  getAllAuctionRooms: data => dispatch(getAllAuctionRooms(data)),
  getBoatTypeStart: data => dispatch(getBoatTypeStart(data)),
  getModuleWiseBanners: type => dispatch(getModuleWiseBanners(type)),
  getBoatSearchMinimumValues: () => dispatch(getBoatSearchMinimumValues()),
  notifyMe: data => dispatch(notifyMe(data)),
  getAllWishlists: data => dispatch(getAllWishlists(data)),
  getCityWiseBoats: data => dispatch(getCityWiseBoats(data)),
  clearAdminLoginFlag: () => dispatch(clearAdminLoginFlag()),
  getUserById: data => dispatch(getUserById(data)),
  getCategoryWiseAdvertisements: data => dispatch(getCategoryWiseAdvertisements(data)),
  // getRecommendedTrips: data => dispatch(getRecommendedTrips(data)),
  getStaticPages: data => dispatch(getStaticPages(data)),
  clear_getStaticPages: () => dispatch(clear_getStaticPages()),
  getYachts: data => dispatch(getYachts(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
